import type { TaskSortField, SortDirection } from './types/task';

export const taskKeys = {
  all: (orgId?: string) => ['tasks', orgId ?? 'unknown'] as const,

  byOrg: (
    orgId: string,
    filtersHash: string,
    sort: string,
    page: number,
    pageSize: number,
  ) => ['tasks', orgId, 'byOrg', filtersHash, sort, page, pageSize] as const,

  byAssignee: (
    orgId: string,
    userId: string,
    filtersHash: string,
    sort: string,
  ) => ['tasks', orgId, 'byAssignee', userId, filtersHash, sort] as const,

  detail: (taskId: string) => ['tasks', 'detail', taskId] as const,

  logs: (taskId: string) => ['tasks', 'logs', taskId] as const,
};

export const buildTaskSortKey = (field: TaskSortField, direction: SortDirection) =>
  `${field}:${direction}`;
